export default __webpack_public_path__ + "static/media/mainimage.a557d50c.svg";